import React from "react";
import Nav from "../../components/nav/Nav";
import { Outlet } from "react-router-dom";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";

const Home = ({ IsAuthenticated, setIsAuthenticated }) => {
  return (
    <div>
      <Nav
        IsAuthenticated={IsAuthenticated}
        setIsAuthenticated={setIsAuthenticated}
      />
      <Outlet />
    </div>
  );
};

export default Home;
